module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.classes
  }, [(!_vm.imgSrc) ? _c('span', {
    class: (_vm.prefixAvatarClass + "__text")
  }, [_vm._v(_vm._s(_vm.text))]) : _c('img', {
    class: (_vm.prefixAvatarClass + "__img"),
    attrs: {
      "src": _vm.imgSrc
    }
  }), _vm._v(" "), (_vm.dot) ? _c('i', {
    class: (_vm.prefixAvatarClass + "__dot")
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-010c1f0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/avatar/avatar.vue
// module id = 336
// module chunks = 0